import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useCreateInvoice } from '../../../hooks/invoice/useCreateInvoice';
import { useUpdateInvoice } from '../../../hooks/invoice/useUpdateInvoice';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import DatePickerMui from '../../common/controls/DatePickerMui';
import dayjs from 'dayjs';

export default function InvoiceForm({ 
  pet = null,
  history = null,
  historyEntry = null,
  successCallback = null, 
  invoice = null, 
  mode = "create", 
  open, 
  onClose 
}) {

  const { t } = useTranslation('common'); 

  const [date, setDate] = React.useState(invoice ? invoice.date : "");
  const [dueDate, setDueDate] = React.useState(invoice ? invoice.due_date : "");
  const [remarks, setRemarks] = React.useState(invoice ? invoice.remarks : "");

  const { create } = useCreateInvoice(successCallback);
  const { update } = useUpdateInvoice(successCallback);

  const { showSnackbar } = useSnackbar();

  const handleDateChange = (date) => {
      setDate(date);
  };

  const handleDueDateChange = (date) => {
      setDueDate(date);
  };

  React.useEffect(() => {
      // reset field when there are changes (e.g. when opening edit)
      setDate(invoice ? invoice.date : "");
      setDueDate(invoice ? invoice.due_date : "");
      setRemarks(invoice ? invoice.remarks : "");
  }, [invoice, open]);


  const handleSave = async () => {

      if (!date.trim()) {
          showSnackbar(t('invoice.payments.messages.date_required'), "warning");
          return;
      }

      const payload = {
          date: date,
          due_date: dueDate,
          history_id: history? history.id : null,
          history_entry_id: historyEntry? historyEntry.id : null,
          pet_id: pet ? pet.id : null,
          pet_owner_id: pet ? pet.owner.id : null,
          remarks: remarks
      };

      try {
          if (mode === "create") {
            await create(payload);
            showSnackbar(t('invoice.messages.create_success'), "success");
            onClose();
          } else if (mode === "edit" && invoice) {
            await update(invoice.id, payload);
            showSnackbar(t('invoice.messages.update_success'), "success");
            onClose();
          }
          setDate("");
          setRemarks("");
          onClose();     // close dialog
      } catch (err) {
          console.log("err.response", err.response);
          showSnackbar(t('invoice.messages.save_fail'), "error");
      }
  };

  const handleCancel = () => {
      setDate("");
      setRemarks("");
      onClose();
  };

  return (
      <>
      <Dialog onClose={handleCancel} open={open} disableRestoreFocus>

      <DialogTitle>{mode === "create" ? "New Invoice" : "Edit Invoice"}</DialogTitle>

      <DialogContent dividers>
          <Stack spacing={1}>
            <DatePickerMui
              value={date ? dayjs(date) : dayjs()}
              label="Date"
              onChange={handleDateChange}
            />
            <DatePickerMui
              value={dueDate ? dayjs(dueDate) : mode === "create" ? dayjs() : null  }
              label="Due Date"
              onChange={handleDueDateChange}
            />
            <TextField
              label="Remarks (optional)"
              variant="outlined"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              fullWidth
              multiline
              rows={2}
            />
          </Stack>
      </DialogContent>

      <DialogActions>
          <Button onClick={handleSave}>
              Save
          </Button>
          <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
      </Dialog>
      </>
  );
}